export default __webpack_public_path__ + "assets/images/Landing_page_img3.91574500.svg";